module.exports = __webpack_public_path__ + "static/media/Grenoble_INP_-_Logo_blanc_RVB.5e17a883.png";